/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';

@Injectable({
  providedIn: 'root'
})
export class CreateColorProfileService {

  /* eslint-disable @typescript-eslint/naming-convention */
  filterMeta = { JOB: [], ASSET: [], CUSTOMERS: [], ORGANISATION: [], PROPERTY: [] };
  iconsAndColorsMeta = {
    JOBS: {
      icons: ['ti-briefcase', 'ti-truck', 'ti-truck-delivery', 'ti-hand-stop', 'ti-player-pause', 'ti-alert-triangle', 'ti-barrier-block', 'ti-barrier-block-off', 'ti-calendar-repeat', 'ti-calendar-clock', 'ti-user-x', 'ti-timeline-event-x'],
      colors: ['#E11D48', '#2563EB', '#DB2777', '#D97706', '#7C3AED', '#059669', '#4F46E5', '#0891B2', '#06B6D4', '#8B5CF6', '#374151', '#0284C7', '#14B8A6', '#EC4899']
    },
    CUSTOMERS: {
      icons: ['ti-user-circle', 'ti-phone-call', 'ti-address-book', 'ti-calendar-user', 'ti-building-skyscraper', 'ti-star'],
      colors: ['#E11D48', '#2563EB', '#DB2777', '#D97706', '#7C3AED', '#059669', '#4F46E5', '#0891B2', '#06B6D4', '#8B5CF6', '#374151', '#0284C7', '#14B8A6', '#EC4899']
    },
    PROPERTY: {
      icons: ['ti-home', 'ti-building-warehouse', 'ti-flag-3', 'ti-map-pin', 'ti-pin', 'ti-building-estate'],
      colors: ['#E11D48', '#2563EB', '#DB2777', '#D97706', '#7C3AED', '#059669', '#4F46E5', '#0891B2', '#06B6D4', '#8B5CF6', '#374151', '#0284C7', '#14B8A6', '#EC4899']
    },
    ASSETS: {
      icons: ['ti-cube', 'ti-box-off', 'ti-tool', 'ti-gavel', 'ti-settings-2', 'ti-tags'],
      colors: ['#E11D48', '#2563EB', '#DB2777', '#D97706', '#7C3AED', '#059669', '#4F46E5', '#0891B2', '#06B6D4', '#8B5CF6', '#374151', '#0284C7', '#14B8A6', '#EC4899']
     }
  };
  /* eslint-enable @typescript-eslint/naming-convention */
  constructor(
    private dataCollectorService: DataCollectorService,
    private toastService: HotToastService,
    private utilityService: UtilityService
  ) { }

  createColorProfile(payload: any, showSuccessToast: boolean = true, callbackStatus: (status: boolean, data?: any) => void): void {
    if (!payload) {
      callbackStatus(false);
    }
    const createColorProfileUrl = `${this.dataCollectorService.baseUrl}/dispatch_board/color_profiles`;
    const loadingToastRef = this.toastService.loading(this.utilityService.getLocaleValue('color_profile.toast.progress.creating', 'Creating Color Profile'));
    this.dataCollectorService.postData(createColorProfileUrl, payload).subscribe((response: any) => {
      loadingToastRef.close();
      callbackStatus(true, response);
      if (showSuccessToast) {
        this.toastService.success(this.utilityService.getLocaleValue('color_profile.toast.complete.create', 'Color Profile Created'));
      }
    },
      (error: any) => {
        loadingToastRef.close();
        callbackStatus(false);
      });
  }

  updateColorProfile(colorProfileUid: string, payload: any, showSuccessToast: boolean = true, callbackStatus: (status: boolean, data?: any) => void): void {
    if (!colorProfileUid || !payload) {
      callbackStatus(false);
    }
    const createColorProfileUrl = `${this.dataCollectorService.baseUrl}/dispatch_board/color_profiles/${colorProfileUid}`;
    const loadingToastRef = this.toastService.loading(this.utilityService.getLocaleValue('color_profile.toast.progress.updating', 'Updating Color Profile'));
    this.dataCollectorService.postData(createColorProfileUrl, payload).subscribe((response: any) => {
      loadingToastRef.close();
      callbackStatus(true, response);
      if (showSuccessToast) {
        this.toastService.success(this.utilityService.getLocaleValue('color_profile.toast.complete.update', 'Color Profile Updated'));
      }
    },
      (error: any) => {
        loadingToastRef.close();
        callbackStatus(false);
      });
  }

}
